export const extractChannelNumberFromId = (channelId: string): number | null => {
  const match = channelId.match(/#C-(\d+)$/);

  return match ? parseInt(match[1], 10) : null;
};
